import React, { useState } from "react";
import "./login.scss";
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext'

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { signIn, googleSignIn, appleSignIn, cancelSignUp } = UserAuth('');

  function isMacOS() {
    return navigator.userAgent.indexOf('Mac') !== -1;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('')
    try {
      await signIn(email, password)
      navigate('/')
    } catch (e) {
      setError(true)
      //console.log(e.message)
    }
  };

  const handleGoogle = async (e) => {
    e.preventDefault();
    setError('')
    try {
      const result = await googleSignIn();
      const canceled = await cancelSignUp(result);
      if (canceled) {
        alert("Cloud Access is only for current subscribers, please create your account using the App");
      } else {
        navigate('/')
      }
    } catch (e) {
      setError(true)
      //console.log(e.message)
    }
  };

  const handleApple = async (e) => {
    e.preventDefault();
    setError('')
    try {
      const result = await appleSignIn();
      const canceled = await cancelSignUp(result);
      if (canceled) {
        alert("Cloud Access is only for current subscribers, please create your account using the App");
      } else {
        navigate('/')
      }
    } catch (e) {
      setError(true)
      //console.log(e.message)
    }
    // try {
    //   await appleSignIn()
    //   navigate('/')
    // } catch (e) {
    //   setError(true)
    //   console.log(e.message)
    // }
  };

  return (
    <div style={{ backgroundImage: `url(https://images.pexels.com/photos/1323550/pexels-photo-1323550.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2)` }} className="login">
      <form onSubmit={handleLogin}>
        <h1>Voicemail Saver & Text Backup</h1>
        <h1>Cloud Access</h1>
        <input
          type="email"
          placeholder="email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
        {error && <span>Wrong email or password!</span>}
        <p style={{ marginTop: 10 }}></p>
        <button type="button"
          onClick={handleGoogle}
          className="socialButton">
          <img
            src={require('../../assets/googleicon.png')}
            alt=""
            className="socialBtn"
          />Sign In with Google
        </button>
        {isMacOS() && (
          <>
            <p style={{ marginTop: 10 }}></p>
            <button type="button"
              onClick={handleApple}
              className="socialButton">
              <img
                src={require('../../assets/appleicon.png')}
                alt=""
                className="socialBtn"
              />Sign In with Apple
            </button>
          </>
        )}
      </form>
      <div style={{ marginTop: 15 }}>
        <form>
          <div style={{}}>
            Offers an easy and intuitive way to backup voicemails, texts and other files from your phone for permanent archival purposes. App will help you save voicemails, texts, contacts, photos, videos, audios and documents. Files are stored in a secure cloud location and from there you can easily download to any other device for safe-keeping. No cables or pin codes required. Basic service is free for all customers. Advanced service is available for a monthly fee, depending on your usage. After you have confirmation that the files are backed up, then you are at liberty to take action and delete from your phone. This will help clear up storage on your phone. We are pioneers in the field of voicemail backup since 2001. This page is only for existing app subscribers. More info: <a href="https://voicemailsaver.com/app" target="_blank">www.voicemailsaver.com/app</a>
          </div>

        </form>

      </div>
      <div className="storesContainer">
        <a href="https://apps.apple.com/us/app/voicemail-saver-text-backup/id6740182332" target="_blank">
        <img
          src={require('../../assets/AppStore.png')}
          alt=""
          className="storesLogo"
        /></a>
        <a href="https://play.google.com/store/apps/details?id=com.voicemailsaver" target="_blank">
        <img
          src={require('../../assets/GooglePlay.png')}
          alt=""
          className="storesLogo"
        /></a>
      </div>

    </div>
  );
};

export default Login;